import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/aggregation_loan_change_log_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered). Parent
// aggregation-loan is unregistered; the belongsTo uses inverse: null (like the
// rest of the batch) since a named inverse to an unregistered type is invalid.
// LegacyMode resolves the belongsTo target lazily so referencing it here is safe.
const AggregationLoanChangeLogSchema = withDefaults({
  type: 'aggregation-loan-change-log',
  fields: [
    { kind: 'attribute', name: 'objectChanges' },
    { kind: 'attribute', name: 'at' },
    {
      kind: 'belongsTo',
      name: 'aggregationLoan',
      type: 'aggregation-loan',
      options: { async: false, inverse: null },
    },
  ],
});

export default AggregationLoanChangeLogSchema;
